import { ProjectContext } from "@shared/containers/Context";
import cx from "classnames";
import PropTypes from "prop-types";
import React, { memo, useContext } from "react";
import { useHistory } from "react-router-dom";

import GameMessage from "./GameMessage";

const DEFAULT_MESSAGE = {
  translates: ["loading"],
};

const DEFAULT_ICON_SETTINGS = {
  size: 64,
};

const MESSAGE_MAP = {
  landscape: {
    translates: ["landscape", "rotate"],
    icon: "rotation",
  },
  portrait: {
    translates: ["portrait", "rotate"],
    icon: "rotation",
    iconSettings: { rotate: -90 },
  },
};

export const GameFrame = memo(({ session, settings }) => {
  const { isLandscapeMode } = useContext(ProjectContext);
  const history = useHistory();

  const isGameShown = Boolean(session);
  const gameMode = {
    isLandscape: settings.isLandscapeMode && !isLandscapeMode,
    isPortrait: settings.isPortraitMode && isLandscapeMode,
  };
  const isMessageShown =
    !isGameShown || gameMode.isLandscape || gameMode.isPortrait;

  const message = {
    ...DEFAULT_MESSAGE,
    ...MESSAGE_MAP[
      gameMode.isLandscape
        ? "landscape"
        : gameMode.isPortrait
        ? "portrait"
        : null
    ],
    iconSettings: {
      ...DEFAULT_ICON_SETTINGS,
      ...MESSAGE_MAP[gameMode.isLandscape ? "landscape" : "portrait"]
        ?.iconSettings,
    },
  };

  return (
    <div
      className={cx("modal__iframe", { "session--scaled": settings.isScaled })}
    >
      {isMessageShown && <GameMessage {...message} isOnTop />}
      {isGameShown && (
        <iframe
          key={session}
          id="gameFrame"
          className="session__frame"
          src={session}
          style={settings.iframeStyle}
          title={settings.title}
          allowFullScreen={window.location.pathname.endsWith("/btm")}
          onLoad={(e) => {
            /*
              Fortune Panda provider's games redirect to the lobby itself
              on click of the "Back" button it the game. It results having
              casino page opened in the iframe. So it was decided to
              redirect the user to the casino page.
            */
            const searchParams = new URLSearchParams(
              e.target.contentWindow?.location.search
            );
            if (searchParams.get("forceGameExit")) {
              history.push("/");
            }
          }}
        />
      )}
    </div>
  );
});

GameFrame.defaultProps = {
  session: null,
  settings: {},
};

GameFrame.propTypes = {
  session: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  settings: PropTypes.shape({
    isLandscapeMode: PropTypes.bool,
    isPortraitMode: PropTypes.bool,
    isScaled: PropTypes.bool,
    iframeStyle: PropTypes.object,
    title: PropTypes.string,
  }),
};

GameFrame.displayName = "GameFrame";
